import { Alert, Box, Button, Table, TableBody, TableCell, TableFooter, TableHead, TablePagination, TableRow } from '@mui/material'
import React, { useEffect, useState } from 'react'
import TablePaginationActions from '../../base-components/TablePaginationActions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faPen, faTrash } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import { useFormik } from 'formik';
import { permissionSchema } from '../../schemas';
import CustomModal from '../../base-components/CustomModal';
import Popup from '../../base-components/Popup';
import { PageHeader } from "../../ui";
const BASE_URL = process.env.REACT_APP_BASE_URL;

function Permissions() {
  const navigate = useNavigate()
  const [permissions , setPermissions] = useState([])
  const [permission , setPermission] = useState({})
  const [permissionToDelete , setPermissionToDelete] = useState('')
  const [permissionToUpdate , setPermissionToUpdate] = useState('')
  const [isAddModalOpen , setIsAddModalOpen] = useState(false)
  const [isViewModalOpen , setIsViewModalOpen] = useState(false)
  const [isDeleteModalOpen , setIsDeleteModalOpen] = useState(false)
  const [isUpdateModalOpen , setIsUpdateModalOpen] = useState(false)
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [page , setPage ] = useState(0)
  const [isSuccessAlert , setIsSuccessAlert] = useState(false)
  const [isFaliureAlert , setIsFailureAlert] = useState(false)
  const [successMessage , setSuccessMessage] = useState('')
  const [failureMessage , setFailureMessage] = useState('')
  const [isPopupOpen , setIsPopupOpen] = useState(false)

  useEffect(()=> {
      getPermissions()
  },[])

  function getPermissions () {
      fetch(BASE_URL + `permissions/getPermissions`)
      .then((response) => response.json())
      .then((data) => {
          setPermissions(data.permissions)
          
      })
      .catch((error) => console.log(error));
  }

  function getPermissionByID (id) {
      fetch(BASE_URL + `permissions/getPermissionById/${id}`)
      .then((response) => response.json())
      .then((data) => {
          setPermission(data.permission)
          setValues({
              name: data.permission.name,
              description: data.permission.description,
          });
      })
      .catch((error) => console.log(error));
  }
  
  const handleAddPermission = async (values, actions) => {
          const requestOptions = {
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
              },
              body: JSON.stringify(values),
          };
  
          try {
              const response = await fetch(BASE_URL + `permissions/createPermission`, requestOptions);
  
              console.log('Response status:', response.status);
              if (!response.ok) {
                  console.error('Response not ok:', response);
                  setIsFailureAlert(true)
                  failureMessage('Failed to add Permission')
                  // handleFailureOpen('Failed to Add Add');
              } else {
                  const responseData = await response.json();
                  console.log('Response data:', responseData);
                  setIsAddModalOpen(false)
                  actions.resetForm()
                  getPermissions()
                  setIsSuccessAlert(true)
                  setSuccessMessage('Permission added Successfully')
                  isPopupOpen(true)
                  setTimeout(() => {
                      setIsPopupOpen(false)
                  } , 5000)
              }
          } catch (error) {
              console.error('Caught error:', error);
              setIsFailureAlert(true) 
              setFailureMessage('Failed to add Permission')
              setIsPopupOpen(true)
              setTimeout(() => {
                  setIsPopupOpen(false)
              } , 5000)
          } finally {
              // setLoading(false);
          }
  
  }

  const handleUpdatePermission = async (values, actions) => {
      const requestOptions = {
          method: "PUT",
          headers: {
              "Content-Type": "application/json",
          },
          body: JSON.stringify(values),
      };

      try {
          const response = await fetch(BASE_URL + `permissions/updatePermission/${permissionToUpdate}`, requestOptions);

          console.log('Response status:', response.status);
          if (!response.ok) {
              console.error('Response not ok:', response);
              setIsFailureAlert(true)
              setFailureMessage('Failed to Update Permission')
              setIsPopupOpen(true)
              setTimeout(() => {
                  setIsPopupOpen(false)
              }, 5000)
          } else {
              const responseData = await response.json();
              console.log('Response data:', responseData);
              actions.resetForm()
              setIsUpdateModalOpen(false)
              getPermissions()
              setIsSuccessAlert(true)
              setSuccessMessage('Permission Updated Successfully')
              setIsPopupOpen(true)
              setTimeout(() => {
                  setIsPopupOpen(false)
              }, 5000)
          }
      } catch (error) {
          console.error('Caught error:', error);
          setIsFailureAlert(true)
          setFailureMessage('Failed to Update Permission')
          setIsPopupOpen(true)
          setTimeout(() => {
              setIsPopupOpen(false)
          }, 5000)
      } finally {
          // setLoading(false);
      }

}

  function deletePermission () {
      const requestOptions = {
          method: "DELETE",
          headers: {
              "Content-Type": "application/json",
          },
      };
      fetch(BASE_URL + `permissions/deletePermission/${permissionToDelete}` , requestOptions)
      .then((response) => response.json())
      .then((data) => {
          getPermissions()
          setIsDeleteModalOpen(false)
          setIsSuccessAlert(true)
          setSuccessMessage('Permission deleted Successfully')
          setIsPopupOpen(true)
          setTimeout(() => {
              setIsPopupOpen(false)
          }, 5000)
      })
      .catch((error) => {
          console.log(error)
          setIsFailureAlert(true)
          setFailureMessage('Failed to delete Permission')
          setIsPopupOpen(true)
          setTimeout(() => {
              setIsPopupOpen(false)
          }, 5000)
      });
  }


  function toggleAddModal() {
      setIsAddModalOpen(!isAddModalOpen)
      resetForm()
  }
  function toggleViewModal() {
      setIsViewModalOpen(!isViewModalOpen)
      resetForm()
  }

  function toggleUpdateModal() {
      setIsUpdateModalOpen(!isUpdateModalOpen)
      resetForm()
  }
  function toggleDeleteModal() {
      setIsDeleteModalOpen(!isDeleteModalOpen)
  }

  function showAddModal(id) {
      setIsAddModalOpen(true);
  }
  function showViewModal(id) {
      getPermissionByID(id);
      setIsViewModalOpen(true);
  }
  function showUpdateModal(id) {

      getPermissionByID(id);
      setPermissionToUpdate(id);
      setIsUpdateModalOpen(true);
  }
  function showDeleteModal(id) {
      setPermissionToDelete(id);
      setIsDeleteModalOpen(true);
  }
  

  const handleChangePage = (event, newPage) => {
      setPage(newPage);
    };
  const handleChangeRowsPerPage = (event) => {
      setRowsPerPage(parseInt(event.target.value, 10));
      setPage(0);
    };

  const {values , touched , errors , handleBlur , handleChange , handleSubmit , setValues , resetForm} = useFormik({
      initialValues: {
          name: '',
          description: '',
      },
      validationSchema: permissionSchema,

      onSubmit: (values, actions) => {
          if(isAddModalOpen){
              handleAddPermission(values, actions); // Call the external function
          } else if(isUpdateModalOpen) {
              handleUpdatePermission(values, actions);
          }
      },
  })
  return (
    <>
        <div className="m-5">
          <PageHeader
            title="Permissions"
            actions={
                  <button className='gx-cta' onClick={showAddModal}>Add Permission</button>
            }
          />
        </div>
        {
            permissions && permissions.length !== 0 ? (     
            <Box className="bg-gx-surface rounded-gx border border-gx-border shadow-gx m-5 animate-fadeIn">
                <Table>
                  <TableHead>
                      <TableRow >
                          <TableCell>Name</TableCell>
                          <TableCell>Description</TableCell>
                          <TableCell>Actions</TableCell>
                      </TableRow>
                  </TableHead>
                  <TableBody>
                    {
                      permissions.map((permission , index) => (
                        <TableRow hover key={index}>
                          <TableCell>{permission.name}</TableCell>
                          <TableCell>{permission.description}</TableCell>
                          <TableCell>
                            <div className='flex gap-2'>
                              <div className='text-gx-ink font-bold hover:cursor-pointer hover:text-green-700' onClick={()=>{
                                showViewModal(permission._id);
                              }}>
                                  <FontAwesomeIcon icon={faEye}/> View 
                              </div>
                              <div className='text-gx-ink font-bold hover:cursor-pointer hover:text-gx-red' onClick={()=>{
                                showUpdateModal(permission._id);
                              }}>
                                  <FontAwesomeIcon icon={faPen}/> Update 
                              </div>
                              <div className='text-gx-ink font-bold hover:cursor-pointer hover:text-red-700'
                              onClick={()=>{
                                showDeleteModal(permission._id);
                              }}
                              >
                                  <FontAwesomeIcon icon={faTrash}/> Delete 
                              </div>
                            </div>
                          </TableCell>
                        </TableRow>
                      ))
                    }
                  </TableBody>
                  <TableFooter>
                      <TableRow>
                      <TablePagination
                          rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                          colSpan={12}
                          count= {permissions.length}
                          rowsPerPage={rowsPerPage}
                          page={page}
                          slotProps={{
                              select: {
                              inputProps: {
                                  'aria-label': 'rows per page',
                              },
                              native: true,
                              },
                          }}
                          onPageChange={handleChangePage}
                          onRowsPerPageChange={handleChangeRowsPerPage}
                          ActionsComponent={TablePaginationActions}
                          />
                      </TableRow>
                  </TableFooter>
              </Table>
            </Box>
            ) : (
              <div className='bg-gx-border w-ful p-3 mt-10 rounded-lg m-10'>
                <h3 className='text-xl font-bold text-center text-gx-ink-soft'>No Records Found</h3>
              </div>
            )
          }

    <CustomModal isModal={isAddModalOpen || isUpdateModalOpen} handleModal = {()=> {
        if(isAddModalOpen){
            toggleAddModal();
        } else if(isUpdateModalOpen) {
            toggleUpdateModal();
        }
    }} size='2xl'>
        <h1 className='font-bold text-3xl text-gx-ink-soft p-5 border-b mx-2'>
            {
                isAddModalOpen ? 'Add Permission' : 'Update Permission' 
            }
        </h1>
        <form onSubmit={handleSubmit} className='text-gx-ink-soft m-5' autoComplete='off'>
            <div>
                <input type='hidden' value={values.company_id}/>
            </div>
            <div className='flex justify-between gap-5 mt-5'>
                <div className='w-full'>
                    <label>Name:</label>
                    <input type='text' name='name' placeholder='Enter Name' 
                        value={values.name}
                        className={'border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 '+ (errors.name && touched.name ? 'border-red-600': '')}
                        onChange={handleChange}
                        onBlur={handleBlur}
                    />
                    {touched.name && errors.name ? <p className='text-red-500 pl-2 italic'>{errors.name}</p> : null}
                </div>
            </div>
            <div className='flex justify-between gap-5 mt-5'>
                <div className='w-full'>
                    <label>Description:</label>
                    <input type='text' name='description' placeholder='Enter Description' 
                        value={values.description}
                        className={'border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 '+ (errors.description && touched.description ? 'border-red-600': '')}
                        onChange={handleChange}
                        onBlur={handleBlur}
                    />
                    {touched.description && errors.description ? <p className='text-red-500 pl-2 italic'>{errors.description}</p> : null}
                </div>
            </div>
            <div className="flex justify-end items-center pt-3 mt-3 border-t">
                <button type='submit' className='bg-blue-600 p-2 px-5 rounded-lg text-white font-medium hover:bg-blue-700'>Submit</button>
            </div>
        </form>
      </CustomModal>
      
      <CustomModal isModal={isViewModalOpen} handleModal = {toggleViewModal} size='2xl'>
        <h1 className='font-bold text-3xl text-gx-ink-soft p-5 border-b mx-2'>View Permission</h1>
        <div className='m-5'>
            <div className='flex justify-start items-center gap-5'>
                <h1 className='font-medium text-xl'>Name:</h1>
                <span className='text-xl'>{permission.name}</span>
            </div>
            <div className='flex justify-start items-center gap-5'>
                <h1 className='font-medium text-xl'>Description:</h1>
                <span className='text-xl'>{permission.description}</span>
            </div>
        </div>
      </CustomModal>

      <CustomModal isModal={isDeleteModalOpen} handleModal={toggleDeleteModal} size='md'>
        <div className='m-5'>
            <h2 className="text-xl font-medium">Delete Permission?</h2>
            <p className="text-gx-ink-soft mt-3">Are you sure you want to delete this permission?</p>
            <button className='bg-red-600 p-2 px-5 rounded-lg text-white font-medium hover:bg-red-700 mt-5 float-right mb-5' onClick={deletePermission}>Delete</button>
        </div>
      </CustomModal>


      {
        isPopupOpen && (
            <Popup 
             onClose={() => setIsPopupOpen(false)}
             alertType={isSuccessAlert ? 'success' : isFaliureAlert ? 'failure' : ''}
             message={isSuccessAlert ? successMessage : isFaliureAlert ? failureMessage : ''}
             />
        )
      }
    </>
  )
}

export default Permissions